"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.replace");
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _utils = require("@/utils");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _commodityManage = require("@/api/_homeCloudPlatform/mall/commodityManage.js");
var _config_treatmentplan = require("@/api/config_treatmentplan");
var _config_treatmentplan_preparations = require("@/api/config_treatmentplan_preparations");
var _config_diseaselist = require("@/api/config_diseaselist");
var _config_preparations = require("@/api/config_preparations");
var _config_usagemethod = require("@/api/config_usagemethod");
var _file = require("@/api/file");
var _user = require("@/api/user");
var _device = require("@/api/device");
var _xlsx = _interopRequireDefault(require("xlsx"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// secondary package based on el-pagination

var defaultPlan = {
  // id: '',
  plan_title: '',
  plan_pic: '',
  plan_desc: '',
  plan_context: '',
  status: 1,
  disease_list: null,
  plan_times: 1,
  lower_price: 0.00,
  highest_price: 0.00,
  owner: '',
  support_go_home: false,
  support_go_shop: false
};
var defaultPreparationsObj = {
  id: '',
  treatment_plan: null,
  preparations: null,
  usage_method: null,
  cup_nums: '',
  day_nums: '',
  preparation_nums: ''
};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      plan: defaultPlan,
      upHeaders: (0, _file.upHeaders)(),
      upUrl: (0, _file.upUrl)(),
      planList: {
        count: 0
      },
      listLoading: true,
      listQuery: {
        page: 1,
        page_size: 10
      },
      dialogVisible: false,
      dialogType: 'new',
      statusType: {
        1: '正常',
        2: '禁用'
      },
      statusData: [{
        key: 1,
        display_name: '正常'
      }, {
        key: 2,
        display_name: '禁用'
      }],
      rule1: {
        plan_title: [{
          required: true,
          message: '请输入C端方案名称',
          trigger: 'blur'
        }, {
          max: 100,
          message: '输入长度不能超过100位'
        }],
        owner: [{
          required: true,
          message: '请选择处方归属人',
          trigger: 'change'
        }]
        // password: [
        //   { required: true, message: '请输入密码', trigger: 'change' }
        // ],
      },
      listPreparationsLoading: true,
      disease_list: [],
      treatment_plan_list: [],
      preparations_list: [],
      usagemethod_list: [],
      dialogPreparationsListVisible: false,
      preparations_tabledata: [],
      preparationsObj: defaultPreparationsObj,
      dialogPreparationsVisible: false,
      dialogPreparationsVisibleType: 'new',
      currentTreatmentPlan: null,
      rule2: {
        preparations: [{
          required: true,
          message: '请选择制剂',
          trigger: 'blur'
        }],
        usage_method: [{
          required: true,
          message: '请选择使用方法',
          trigger: 'blur'
        }]
      },
      user: [],
      api: process.env.VUE_APP_BASE_API,
      total: null,
      count: null,
      table: [],
      rowData: [],
      goodsCount: 0,
      //搜寻方案被商品使用数量
      goodsList: []
    };
  },
  created: function created() {
    this.getList();
    this.getDiseaseListAll();
    this.getPreparationsAll();
    this.getUsageMethodAll();
    this.getUserList();
  },
  methods: {
    checkPermission: _permission.default,
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.plan.plan_pic = process.env.VUE_APP_BASE_API + res.data.path;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传封面图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: 10,
        support_go_home: '',
        support_go_shop: ''
      };
      this.getList();
    },
    getUserList: function getUserList() {
      var _this = this;
      this.user.length = 0;
      (0, _user.getUserList)({
        commission_branches: 6,
        page_size: 100
      }).then(function (res) {
        for (var i = 0; i < res.data.count; i++) {
          _this.user.push(res.data.results[i]);
        }
        // this.user = res.data.results
        console.log(_this.user);
      });
    },
    //搜寻方案是否有商品使用
    getGoodsCountbyPlanId: function () {
      var _getGoodsCountbyPlanId2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(id) {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 等待 getGoodsCountbyPlanId 完成
              console.log('id', id);
              _context.next = 3;
              return (0, _commodityManage.getGoodsCountbyPlanId)({
                c_plan: id,
                page_size: 100
              });
            case 3:
              res = _context.sent;
              this.goodsCount = res.count || 0;
              this.goodsList = res.results || [];
              console.log('getGoodsCountbyPlanId res', res);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getGoodsCountbyPlanId(_x) {
        return _getGoodsCountbyPlanId2.apply(this, arguments);
      }
      return getGoodsCountbyPlanId;
    }(),
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _config_treatmentplan.getTreatmentPlanList)(this.handleQuery()).then(function (response) {
        if (response.data) {
          _this2.planList = response.data;
          _this2.count = response.data.count;
        }
        _this2.listLoading = false;
      });
    },
    getDiseaseListAll: function getDiseaseListAll() {
      var _this3 = this;
      (0, _config_diseaselist.getDiseaseListAll)().then(function (res) {
        var data = res.data;
        data = data.map(function (item) {
          item.value = item.id;
          item.name = item.disease_name;
          return item;
        });
        _this3.disease_list = (0, _utils.genTree)(data);
      });
    },
    getPreparationsAll: function getPreparationsAll() {
      var _this4 = this;
      (0, _config_preparations.getPreparationsAll)().then(function (res) {
        var data = res.data;
        data = data.map(function (item) {
          item.value = item.id;
          item.name = item.preparations_name;
          return item;
        });
        _this4.preparations_list = (0, _utils.genTree)(data);
      });
    },
    getUsageMethodAll: function getUsageMethodAll() {
      var _this5 = this;
      (0, _config_usagemethod.getUsageMethodAll)().then(function (res) {
        var data = res.data;
        data = data.map(function (item) {
          item.value = item.id;
          item.name = item.acupoint_name;
          return item;
        });
        _this5.usagemethod_list = (0, _utils.genTree)(data);
      });
    },
    handleAddPlan: function handleAddPlan() {
      var _this6 = this;
      this.plan = Object.assign({}, defaultPlan);
      this.dialogType = 'new';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this6.$refs['Form'].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this7 = this;
      this.plan = Object.assign({}, scope.row); // copy obj
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this7.$refs['Form'].clearValidate();
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(form) {
        var _this8 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this8.dialogType === 'edit';
                  if (isEdit) {
                    // 移除api domain
                    _this8.plan.plan_pic = _this8.plan.plan_pic.replace(process.env.VUE_APP_BASE_API, '');
                    (0, _config_treatmentplan.updateTreatmentPlan)(_this8.plan.id, _this8.plan).then(function (res) {
                      _this8.getList();
                      _this8.dialogVisible = false;
                      _this8.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else {
                    // 移除api domain
                    _this8.plan.plan_pic = _this8.plan.plan_pic.replace(process.env.VUE_APP_BASE_API, '');
                    (0, _config_treatmentplan.createTreatmentPlan)(_this8.plan).then(function (res) {
                      _this8.getList();
                      _this8.dialogVisible = false;
                      _this8.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function confirm(_x2) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    handlePreparations: function handlePreparations(scope) {
      var _this9 = this;
      this.preparations_tabledata = null;
      this.currentTreatmentPlan = null;
      this.currentTreatmentPlan = {
        id: scope.row.id,
        name: scope.row.plan_title
      };
      this.listPreparationsLoading = true;
      this.dialogPreparationsListVisible = true;
      (0, _config_treatmentplan_preparations.getPlanOtherList)({
        treatmentplan: scope.row.id
      }).then(function (res) {
        _this9.preparations_tabledata = res.data;
        _this9.listPreparationsLoading = false;
      });
    },
    handleAddPreparations: function handleAddPreparations(scope) {
      var _this10 = this;
      this.preparationsObj = Object.assign({}, defaultPreparationsObj);
      this.dialogPreparationsVisibleType = 'new';
      this.treatment_plan_list = (0, _utils.genTree)([{
        id: this.currentTreatmentPlan.id,
        name: this.currentTreatmentPlan.name
      }]);
      this.preparationsObj.treatment_plan = this.currentTreatmentPlan.id;
      this.dialogPreparationsVisible = true;
      this.$nextTick(function () {
        _this10.$refs['PreparationsForm'].clearValidate();
      });
    },
    handleEditPreparations: function handleEditPreparations(scope) {
      var _this11 = this;
      this.preparationsObj = Object.assign({}, scope.row); // copy obj
      this.dialogPreparationsVisibleType = 'edit';
      this.treatment_plan_list = (0, _utils.genTree)([{
        id: this.currentTreatmentPlan.id,
        name: this.currentTreatmentPlan.name
      }]);
      this.dialogPreparationsVisible = true;
      this.$nextTick(function () {
        _this11.$refs['PreparationsForm'].clearValidate();
      });
    },
    handleDeletePreparations: function handleDeletePreparations(scope) {
      var _this12 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return (0, _config_treatmentplan_preparations.deletePlanOther)(scope.row.id);
            case 2:
              (0, _config_treatmentplan_preparations.getPlanOtherList)({
                treatmentplan: _this12.preparationsObj.treatment_plan
              }).then(function (res) {
                _this12.preparations_tabledata = res.data;
                _this12.dialogPreparationsVisible = false;
                _this12.$message({
                  type: 'success',
                  message: '成功删除!'
                });
              });
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    handleDelete: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(scope) {
        var _this13 = this;
        var goodsString;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.getGoodsCountbyPlanId(scope.row.id);
            case 2:
              goodsString = this.goodsList.map(function (item) {
                return item.id;
              }).join(',') || '';
              console.log('goodsCount', this.goodsCount);
              console.log('goodsString', goodsString);
              if (this.goodsCount > 0) {
                //方案有被商品绑定无法删除
                this.$alert("\u6B64\u65B9\u6848\u5DF2\u6709\u7ED1\u5B9A\u4EE5\u4E0B\u5546\u54C1id\u65E0\u6CD5\u88AB\u5220\u9664\uFF1A".concat(goodsString), '警告', {
                  confirmButtonText: '确认',
                  type: 'warning'
                });
              } else {
                //方案无商品绑定确认删除
                this.$confirm('确认删除?', '警告', {
                  confirmButtonText: '确认',
                  cancelButtonText: '取消',
                  type: 'error'
                }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
                  return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.next = 2;
                        return (0, _config_treatmentplan.deleteTreatmentPlan)(scope.row.id);
                      case 2:
                        _this13.getList();
                        _this13.$message({
                          type: 'success',
                          message: '成功删除!'
                        });
                      case 4:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }))).catch(function () {
                  return;
                });
              }
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleDelete(_x3) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }(),
    confirmPreparations: function () {
      var _confirmPreparations = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6(form) {
        var _this14 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this14.dialogPreparationsVisibleType === 'edit';
                  if (isEdit) {
                    (0, _config_treatmentplan_preparations.updatePlanOther)(_this14.preparationsObj.id, _this14.preparationsObj).then(function (res) {
                      (0, _config_treatmentplan_preparations.getPlanOtherList)({
                        treatmentplan: _this14.preparationsObj.treatment_plan
                      }).then(function (res) {
                        _this14.preparations_tabledata = res.data;
                        _this14.dialogPreparationsVisible = false;
                        _this14.$message({
                          message: '编辑成功',
                          type: 'success'
                        });
                      });
                    });
                  } else {
                    (0, _config_treatmentplan_preparations.createPlanOther)(_this14.preparationsObj).then(function (res) {
                      (0, _config_treatmentplan_preparations.getPlanOtherList)({
                        treatmentplan: _this14.preparationsObj.treatment_plan
                      }).then(function (res) {
                        _this14.preparations_tabledata = res.data;
                        _this14.dialogPreparationsVisible = false;
                        _this14.$message({
                          message: '编辑成功',
                          type: 'success'
                        });
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function confirmPreparations(_x4) {
        return _confirmPreparations.apply(this, arguments);
      }
      return confirmPreparations;
    }(),
    changePreNums: function changePreNums() {
      this.preparationsObj.preparation_nums = this.preparationsObj.cup_nums;
    },
    changeCpuNums: function changeCpuNums() {
      this.preparationsObj.cup_nums = this.preparationsObj.preparation_nums;
    },
    getTotal: function getTotal(scope) {
      var a = scope.row.total_treatmentpart;
      var b = scope.row.plan_times;
      // console.log(a)
      // console.log(b)
      if (a === 0 || b === 0) {
        return 0;
      } else {
        return a * b;
      }
    },
    handleExport: function handleExport() {
      var _this15 = this;
      var excelData = [['序号', 'C端方案名称', 'C端方案描述', 'C端方案详细内容', '状态', '方案编码', '疾病名称', '调理次数', '单词制剂数', '总制剂数', '最低价格', '显示价格']];
      // console.log(this.count)
      (0, _config_treatmentplan.getTreatmentPlanList)({
        page: 1,
        page_size: this.count
      }).then(function (response) {
        _this15.table = response.data.results;
        for (var i = 0; i < _this15.table.length; i++) {
          _this15.rowData = [i + 1, _this15.table[i].plan_title, _this15.table[i].plan_desc, _this15.table[i].plan_context, _this15.table[i].status, _this15.table[i].plan_no, _this15.table[i].disease_list_name, _this15.table[i].plan_times, _this15.table[i].total_treatmentpart, _this15.table[i].plan_times * _this15.table[i].total_treatmentpart, _this15.table[i].lower_price, _this15.table[i].highest_price];
          console.log(_this15.rowData);
          excelData.push(_this15.rowData);
        }
        console.log(_this15.table);
        var ws = _xlsx.default.utils.aoa_to_sheet(excelData);
        var wb = _xlsx.default.utils.book_new();
        _xlsx.default.utils.book_append_sheet(wb, ws, 'plan');
        _xlsx.default.writeFile(wb, 'plan.xlsx');
      });
    },
    handleQuery: function handleQuery() {
      var query = (0, _objectSpread2.default)({}, this.listQuery);
      if (query.support_go_home === '') {
        query.support_go_home = function () {
          return;
        }();
      }
      if (query.support_go_shop === '') {
        query.support_go_shop = function () {
          return;
        }();
      }
      return query;
    }
  }
};